export function getOffsetTop(node: HTMLElement, offset: number = 0) {
  let location = 0;
  let nextNode = node;

  if (nextNode.offsetParent) {
    do {
      location += nextNode.offsetTop;
      nextNode = nextNode.offsetParent as HTMLElement;
    } while (nextNode);
  }

  return location - offset;
}
